export default __webpack_public_path__ + "static/GRID22-breakdown-542a122938cc6d2cdd692d5d89c663c4.png";